var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 17.5C13.8063 17.5 17.5 13.8063 17.5 9.25C17.5 4.69365 13.8063 1 9.25 1C4.69365 1 1 4.69365 1 9.25C1 13.8063 4.69365 17.5 9.25 17.5Z",
    stroke: "#C90000",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14.0625C9.81954 14.0625 10.2812 13.6008 10.2812 13.0312C10.2812 12.4617 9.81954 12 9.25 12C8.68046 12 8.21875 12.4617 8.21875 13.0312C8.21875 13.6008 8.68046 14.0625 9.25 14.0625Z",
    fill: "#C90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.125V9.9375",
    stroke: "#C90000",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerCircleRed);
export default __webpack_public_path__ + "static/media/danger-circle-red.d41e033b7f62ffc2a9a3ec03d59c6311.svg";
export { ForwardRef as ReactComponent };